import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';
import { provideFuse } from '@fuse';
import { appRoutes } from 'app/app.routes';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { provideTransloco } from 'app/core/transloco/transloco.provider';
import { mockApiServices } from 'app/mock-api';
import { AppConfig } from './config/service.config';
import { initializeApp } from './app.component';
import { provideCore } from './core/core.provider';
import { LoyaltyTokenService } from 'app/core/loyalty/loyalty-token.service';

    export const appConfig: ApplicationConfig = {
        providers: [
            provideAnimations(),
            provideHttpClient(),
            provideRouter(appRoutes,
                withPreloading(PreloadAllModules),
                withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
            ),

            // Material Date Adapter
            {
                provide: DateAdapter,
                useClass: LuxonDateAdapter,
            },
            {
                provide: MAT_DATE_FORMATS,
                useValue: {
                    parse: {
                        dateInput: 'D',
                    },
                    display: {
                        dateInput: 'DDD',
                        monthYearLabel: 'LLL yyyy',
                        dateA11yLabel: 'DD',
                        monthYearA11yLabel: 'LLLL yyyy',
                    },
                },
            },

            // Transloco Config
            provideTransloco(),

            // Fuse
            provideAuth(),
            provideIcons(),
            provideFuse({
                mockApi: {
                    delay: 0,
                    services: mockApiServices,
                },
                fuse: {
                    layout: 'classy',
                    scheme: 'light',
                    screens: {
                        sm: '600px',
                        md: '960px',
                        lg: '1280px',
                        xl: '1440px',
                    },
                    theme: 'theme-eKedai',
                    themes: [
                        {
                            id: 'theme-default',
                            name: 'Default',
                        },
                        {
                            id: 'theme-eKedai',
                            name: 'eKedai',
                        },
                        {
                            id: 'theme-brand',
                            name: 'Brand',
                        },
                        {
                            id: 'theme-teal',
                            name: 'Teal',
                        },
                        {
                            id: 'theme-rose',
                            name: 'Rose',
                        },
                        {
                            id: 'theme-purple',
                            name: 'Purple',
                        },
                        {
                            id: 'theme-amber',
                            name: 'Amber',
                        },
                    ],
                },
            }),
            provideCore(),
            AppConfig,
            {
                provide: APP_INITIALIZER,
                useFactory: initializeApp,
                deps: [AppConfig],
                multi: true
            },
            {
                provide: APP_INITIALIZER,
                useFactory: loadLoyaltyToken,
                deps: [LoyaltyTokenService],
                multi: true
            },
        ],
    };

    export function loadLoyaltyToken(
        loyaltyService: LoyaltyTokenService
    ) {
        return () => loyaltyService.load();
    }

